import { all, fork } from 'redux-saga/effects';

import { watchGetAllDemandDataImportSummaries } from './demand/sagas';

export function* dataImportsSaga() {
  yield all([fork(watchGetAllDemandDataImportSummaries)]);
}
